import {useRef} from 'react';
import ReactPaginate from 'react-paginate';
import {useRouter} from 'next/router';

const classNameProps = {
  containerClassName: 'flex justify-center items-center mt-24 mb-16 max-w-[80%] mx-auto',
  pageClassName: 'w-8 opacity-40',
  activeClassName: '!opacity-100',
  previousClassName: 'w-8 text-xl',
  nextClassName: 'w-8 text-xl',
  disabledClassName: 'opacity-40',
  breakClassName: 'w-8 opacity-40',
  pageLinkClassName: 'text-brand-dark-blue visited:text-brand-dark-blue',
  nextLinkClassName: 'text-brand-dark-blue visited:text-brand-dark-blue',
  previousLinkClassName: 'text-brand-dark-blue visited:text-brand-dark-blue',
};

const Paginator = ({allItems, itemsPerPage = 8, defaultPage = 1, children}) => {
  const pageCount = Math.ceil(allItems.length / itemsPerPage);
  const router = useRouter();
  const currentPage = router.query.page ? parseInt(router.query.page as string, 10) : defaultPage;
  const getHref = (page: number) => {
    const baseURL = router.asPath.split('/page')[0];
    return `${baseURL}/page/${page}`;
  };
  const setCurrentPage = page => {
    router.push(
      {
        pathname: getHref(page),
      },
      undefined,
      {scroll: false}
    );
  };
  const containerRef = useRef<HTMLDivElement>(null);
  const handlePageClick = ({selected: selectedPageIndex}: {selected: number}) => {
    setCurrentPage(selectedPageIndex + 1);
    containerRef.current?.scrollIntoView({behavior: 'smooth'});
  };

  const pageIndex = currentPage - 1;

  return (
    <div ref={containerRef}>
      {children(
        allItems.slice((pageIndex * itemsPerPage) % allItems.length, (pageIndex + 1) * itemsPerPage)
      )}
      <ReactPaginate
        nextLabel=">"
        previousLabel="<"
        pageCount={pageCount}
        forcePage={pageIndex}
        onPageChange={handlePageClick}
        hrefBuilder={pageIndex => getHref(pageIndex)}
        {...classNameProps}
      />
    </div>
  );
};

export default Paginator;
